var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 3.94522L10.625 0L21.125 3.94522L21.125 11.4607C21.125 15.5354 19.0911 19.3412 15.7035 21.6055L10.625 25L5.54646 21.6055C2.15885 19.3412 0.125 15.5354 0.125 11.4607L0.125 3.94522Z",
    fill: "#FF3B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.25449V9.61882V13.3672V14.2277C9.5 14.548 9.63924 14.8877 9.8676 15.1133C10.0848 15.3305 10.4413 15.4948 10.7532 15.4809C11.0762 15.467 11.4132 15.3612 11.6388 15.1133C11.8643 14.8682 12.0064 14.5675 12.0064 14.2277C12.0064 13.4396 12.0064 12.6515 12.0064 11.8634C12.0064 10.613 12.0064 9.3654 12.0064 8.11501C12.0064 7.82817 12.0064 7.54133 12.0064 7.25449C12.0064 6.93423 11.8671 6.59448 11.6388 6.36891C11.4215 6.15169 11.0651 5.98739 10.7532 6.00131C10.4301 6.01524 10.0932 6.12106 9.8676 6.36891C9.64203 6.61398 9.5 6.91474 9.5 7.25449Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.7337V18.1041C9.5 18.4244 9.63924 18.7641 9.8676 18.9897C9.98178 19.1122 10.1155 19.1985 10.2714 19.2487C10.4218 19.3266 10.5805 19.3628 10.7532 19.3573C11.0762 19.3434 11.4132 19.2375 11.6388 18.9897C11.8643 18.7446 12.0064 18.4438 12.0064 18.1041C12.0064 17.9816 12.0064 17.8562 12.0064 17.7337C12.0064 17.4135 11.8671 17.0737 11.6388 16.8481C11.5246 16.7256 11.3909 16.6393 11.235 16.5891C11.0846 16.5112 10.9258 16.475 10.7532 16.4805C10.4301 16.4945 10.0932 16.6003 9.8676 16.8481C9.64203 17.0932 9.5 17.394 9.5 17.7337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/red-alert.0e02e120af41b6cd7287059c0430d53b.svg";
export { ForwardRef as ReactComponent };